import { FC, useState, forwardRef } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { Flex } from '../Flex';

interface AccordionProps {
    heading: string;
}

const Accordian: FC<AccordionProps> = forwardRef(({ heading, children }, ref) => {
    const [open, setIsOpen] = useState(false);

    return (
        <Box borderRadius="16px" overflow="hidden" border="#FEEDAA solid 1px" ref={ref}>
            <Flex
                onClick={() => setIsOpen((previousState) => !previousState)}
                alignItems="center"
                justifyContent="space-between"
                padding="16px"
                color="#1D1D1B"
                bgcolor="#FEE380"
            >
                <Typography fontSize="20px" fontWeight={500} lineHeight="24px">
                    {heading}
                </Typography>
                {open ? <ExpandLess /> : <ExpandMore />}
            </Flex>
            {open && <Box padding="24px">{children}</Box>}
        </Box>
    );
});

export default Accordian;
